module.exports = __webpack_public_path__ + "img/7_68.6df3ca6f.png";